// extracted by mini-css-extract-plugin
module.exports = {"settings":"AdvancedSettings_settings_1_pck"};